import { ca } from '@cian/analytics';

import { RANDOM_MACRO, RANDOM_MACRO_MAX, RANDOM_MACRO_MIN } from './constants';
import { getRandomInRange } from '../../../utils/getRandomInRange';

const WEBORAMA_IMPRESSION_URL =
  'https://wcm.weborama-tech.ru/fcgi-bin/dispatch.fcgi?a.A=im&a.si=10204&a.te=4614&a.he=1&a.wi=1&a.hr=p&a.ra=[RANDOM]';

export function trackDailyrentBannerClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'Click',
    label: 'dailyrent_banner',
  });
}

export function trackDailyrentBannerShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'show_sopr',
    label: 'dailyrent_banner',
  });
}

export function trackDailyrentBannerWeboramaShow() {
  const pixel = new Image();

  pixel.src = WEBORAMA_IMPRESSION_URL.replace(
    RANDOM_MACRO,
    String(getRandomInRange(RANDOM_MACRO_MIN, RANDOM_MACRO_MAX)),
  );
}
